function getNextWorkingDay() {
  const today = new Date();
  const dayOfWeek = today.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

  let daysToAdd;
  if (dayOfWeek === 6) {
    // Saturday -> Next working day is Tuesday
    daysToAdd = 3;
  } else if (dayOfWeek === 0) {
    // Sunday -> Next working day is Tuesday

function getNextWorkingDay() {
  const today = new Date();
  const dayOfWeek = today.getDay();
  
  const daysToAdd = dayOfWeek === 5 ? 3 : dayOfWeek === 6 ? 2 : 1;

  const nextWorkingDay = new Date(today);
  nextWorkingDay.setDate(today.getDate() + daysToAdd);

  return nextWorkingDay;
}
 var element = document.querySelector(".custom-inventory-text span");
 // var element = document.querySelector(".product-info__inventory .text-with-icon.text-success span>span");

var nextWorkingDay = getNextWorkingDay();
var dayNames = ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"];
var monthNames = ["januari", "februari", "maart", "april", "mei", "juni",
  "juli", "augustus", "september", "oktober", "november", "december"
];
var formattedNextWorkingDay = dayNames[nextWorkingDay.getDay()] + " " + nextWorkingDay.getDate() + " " + monthNames[nextWorkingDay.getMonth()];

element.append(formattedNextWorkingDay);

  }
}
